// src/utils/apiUtils.ts
import { buildSignature } from '@/utils/signUtis';


export const fetchData = async (url?: string, params?: Record<string, unknown>): Promise<unknown> => {
  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  return commonPostRequest<unknown>(url, params);
};


export const removeToken = async (): Promise<unknown> => {
  const t = localStorage.getItem('ADOPT_TOKEN');
  if (t) {
    try {
      const headers: Record<string, string> = {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${t}`,
      };
      await fetch('/api/adoptappli/invalidToken', {
        method: 'POST',
        headers,
        body: JSON.stringify({}),
      });
    } catch (error) {
      console.error('Token invalidation failed:', error);
    } finally {
      console.log('移除token.....');
      localStorage.removeItem('ADOPT_TOKEN');
    }
  }
};


/**
 * 通用的签名POST请求函数
 * @param url 请求URL
 * @param params 请求参数
 * @returns Promise<T> 返回数据
 */
export const commonPostRequest = async <T>(
  url: string,
  params?: Record<string, any>
): Promise<T> => {
  try {
    // 检查params中euid是否为空
    if (params && ('euid' in params) && (params.euid === '' || params.euid === null || params.euid === undefined)) {
      return null as T; // 直接返回null，不发起请求
    }
    // 复制参数对象，避免 buildSignature 修改原始对象
    const paramsForSignature = { ...params };
    // 生成签名
    const requestData = buildSignature(paramsForSignature);
    // 构建请求头
    const headers: Record<string, string> = {
      'Content-Type': 'application/json',
    };
    // 獲取token
    const applyToken = localStorage.getItem('ADOPT_TOKEN');
    // 如果有 apply_token，则添加到 Authorization header
    if (applyToken) {
      headers.Authorization = `Bearer ${applyToken}`;
    }
    const response = await fetch(url, {
      method: 'POST',
      headers,
      body: JSON.stringify(requestData),
    });
    if (!response.ok) {
      console.error('403 Forbidden - Token无效或过期，跳转到首页');
      localStorage.removeItem('ADOPT_TOKEN');
      window.location.href = '/foster-apply-list?platform=personal';
      throw new Error('403 Forbidden');
    }
    const data = await response.json();
    return data;
  } catch (error) {
    console.error('请求失败:', error);
    throw error;
  }
};

/**
 * 通用的FormData POST请求函数
 * @param url 请求URL
 * @param params 请求参数
 * @returns Promise<T> 返回数据
 */
export const formDataPostRequest = async <T>(
  url: string,
  params?: Record<string, any>
): Promise<T> => {
  try {
    const formData = new FormData();
    Object.keys(params).forEach(key => {
      formData.append(key, params[key]);
    });

    const response = await fetch(url, {
      method: 'POST',
      body: formData,
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('请求失败:', error);
    throw error;
  }
};
